// Small screens and touch devices have no hover effect, so the lifestyle (second) photo of a product
// card never showed there. While a card's image crosses the middle of the screen it gets
// `.is-lifestyle`; the CSS (component-card.css, sections/product-recommendations.liquid) decides where
// that class swaps the photo (below 990px or on touch devices), so a narrow desktop window, a tablet
// and every phone behave the same.
(function () {
  if (!('IntersectionObserver' in window)) return;

  // A thin band across the middle of the viewport: only one row of cards is inside it at a time.
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-lifestyle', entry.isIntersecting));
    },
    { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
  );

  const seen = new WeakSet();
  function observeCards(root) {
    // Catalogue product cards and the product page "Recomendaciones para ti" cards.
    root.querySelectorAll('.product-card .media--hover-effect, .mangue-rec__img-wrap').forEach((media) => {
      if (seen.has(media) || !media.querySelector('img + img')) return;
      seen.add(media);
      observer.observe(media);
    });
  }

  function init() {
    observeCards(document);
    // Filters, sorting and "load more" replace or add cards without a page load.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        observeCards(document);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
